import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { PawPrint, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

export default function AdminLogin() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await api.post('/admin/login', { username, password });
            localStorage.setItem('cloudpet-admin-token', res.data.token);
            toast.success('Bienvenido al panel de administracion');
            navigate('/admin');
        } catch {
            toast.error('Credenciales invalidas');
        }
        setLoading(false);
    };

    return (
        <div className="min-h-screen hero-gradient flex items-center justify-center px-4" data-testid="admin-login-page">
            <div className="w-full max-w-sm">
                <div className="text-center mb-8">
                    <div className="inline-flex items-center justify-center w-16 h-16 bg-cp-brand rounded-2xl mb-4">
                        <PawPrint size={28} className="text-white" />
                    </div>
                    <h1 className="font-heading font-bold text-2xl text-cp-text-main">CloudPet Admin</h1>
                    <p className="text-cp-text-muted text-sm mt-1">Ingresa al panel de administracion</p>
                </div>
                <form onSubmit={handleSubmit} className="bg-white border border-cp-border rounded-2xl p-6 shadow-sm" data-testid="login-form">
                    <div className="space-y-4 mb-6">
                        <div>
                            <Label htmlFor="username" className="text-cp-text-body text-sm mb-1.5 block">Usuario</Label>
                            <Input id="username" value={username} onChange={e => setUsername(e.target.value)}
                                data-testid="login-username" required placeholder="admin" className="border-cp-border" />
                        </div>
                        <div>
                            <Label htmlFor="password" className="text-cp-text-body text-sm mb-1.5 block">Contrasena</Label>
                            <Input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)}
                                data-testid="login-password" required className="border-cp-border" />
                        </div>
                    </div>
                    <button
                        type="submit"
                        disabled={loading}
                        data-testid="login-submit"
                        className="w-full flex items-center justify-center gap-2 bg-cp-secondary hover:bg-cp-secondary-hover disabled:opacity-60 text-white py-3 rounded-xl font-semibold transition-all"
                    >
                        {loading && <Loader2 size={16} className="animate-spin" />}
                        Ingresar
                    </button>
                </form>
            </div>
        </div>
    );
}
